import { ReactElement } from "react";
import styles from "./FormImageAttachment.module.less";
import { BusyIndicator, IconButton } from "client/Components";
import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";

export type FormImageAttachmentProps = {
	onDelete: () => void;
	variant?: "mobile" | "normal";
	hasBackground?: boolean;
	trackingId: string;
} & ({
	isLoading: true;
} | {
	isLoading?: false;
	src: string;
});

export const FormImageAttachment = (
	props: FormImageAttachmentProps
): ReactElement => {
	const {
		onDelete,
		variant = "normal",
		hasBackground = false,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{
					[styles.root_mobile]: variant === "mobile",
					[styles.root_hasBackground]: hasBackground,
				}
			)}
		>
			<div className={styles.button}>
				<IconButton
					icon={{
						kind: "font",
						name: "xmark",
						color: "white"
					}}
					kind="transparent-colored"
					trackingId="delete-button"
					onClick={onDelete}
					shape="round"
				/>
			</div>
			{props.isLoading
				? (
					<BusyIndicator />
				)
				: (
					<img
						src={props.src}
						className={styles.img}
						alt=""
					/>
				)}
		</div>
	);
};
FormImageAttachment.displayName="FormImageAttachment";
